import $ from 'jquery';
import { getOrientation, isMobile, isMobileScreen, isTouchDevice } from '../../util/device.js';
// import mpro from './mpro.init';

// Current environment
// eslint-disable-next-line n/no-process-env
mpro.isDev = process.env.NODE_ENV === 'development';

mpro.isMobile = isMobile;
mpro.isTouchDevice = isTouchDevice;
// Fast mobile device detection
mpro.isMobileScreen = isMobileScreen;
mpro.getOrientation = getOrientation;

const getBrowser = () => {
	return (/trident/i.test(navigator.userAgent))
		? 'ie'
		: (
			/opr\/\d/i.test(navigator.userAgent)
				? 'opera'
				// No need to detect edge-chrome or others such this, they are all webkit chrome
				: (navigator.userAgent.match(/(edge)/i) || navigator.userAgent.match(/(chrome|firefox|safari)/i))?.[0]?.toLowerCase() || 'unknown'
		);
};

const getOS = () => {
	// const userAgent = window.navigator.userAgent;
	const { platform } = window.navigator;
	// const version = window.navigator.appVersion;
	// const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	// const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	// const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os = null;

	if (platform.includes('Win')) {
		os = 'windows';
	}
	else if (platform.includes('iPhone') || platform.includes('iPad') || platform.includes('iPod')) {
		os = 'ios';
	}
	else if (platform.includes('Mac')) {
		os = 'macos';
	}
	else if (platform.includes('Android')) {
		os = 'android';
	}
	else if (platform.includes('X11')) {
		os = 'unix';
	}
	else if (platform.includes('Linux')) {
		os = 'linux';
	}
	else {
		os = 'unknown';
	}

	return os;
};

// Explain UserAgent
/** @type {{ browser: string; os: string; }} */
let uaData;
mpro.explainUa = () => {
	if (!uaData) {
		uaData = {
			browser: getBrowser(),
			os: getOS(),
		};
	}

	return uaData;
};

/**
 * Determine if there is guest available
 */
mpro.isGuest = () => {
	return mpro.config?.customer?.id > 0;
};

mpro.isDarkPreferred = () => {
	return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

// ==================
// JS Location detect
// ==================

mpro.determineLocation = function(opt, cb) {

	opt = opt || {};
	const highAccuracy = opt.highAccuracy || false;
	const getCookie = opt.getCookie || false;
	const setCookie = opt.setCookie || false;
	const limitGeoPrompt = opt.limitGeoPrompt || {};
	const limitGeoPromptCookieName = limitGeoPrompt.cookie || null;
	const limitGeoPromptCookieValue = limitGeoPrompt.cookie ? (Number.parseInt(mpro.Cookies.get(limitGeoPrompt.cookie), 10) || 0) : 0;
	const limitGeoPromptLimit = limitGeoPrompt.limit || null;
	const limitGeoPromptReturnLast = limitGeoPrompt.returnLast || false;
	const geoCookieName = mpro.config.geo_cookie_name;
	const cookieValue = mpro.Cookies.get(geoCookieName);
	let cookieLocation;

	// Decode saved value from cookie
	try {
		cookieLocation = JSON.parse(cookieValue) || [];
	}
	catch {
		cookieLocation = [];
	}

	// Get cached data
	if (getCookie && cookieLocation.length > 0) {
		// Return value from cookie
		cb && cb(cookieLocation);
		return;
	}

	// Check the geo prompt cookie limit
	if ((limitGeoPromptLimit !== null) && limitGeoPromptCookieName && // Reached limit
		limitGeoPromptCookieValue >= limitGeoPromptLimit) {
		// Return
		cb && cb((limitGeoPromptReturnLast === 'cookie') ? cookieLocation : []);
		return;
	}

	// JS location detect
	if (window.navigator.geolocation && window.navigator.geolocation.getCurrentPosition) {

		// Increment the global counter
		if (limitGeoPromptCookieName) {
			mpro.Cookies.set(limitGeoPromptCookieName, String(limitGeoPromptCookieValue + 1), { expires: null });
		}

		window.navigator.geolocation.getCurrentPosition((pos) => {
			// Position {coords: Coordinates, timestamp: 1507907951287}
			// Coordinates {latitude: xx.xxxxxx, longitude: xx.xxxxxxx, altitude: null, accuracy: 4786, altitudeAccuracy: null, heading: null, speed: null}
			if (setCookie && geoCookieName) {
				mpro.Cookies.set(geoCookieName, JSON.stringify([pos.coords.latitude, pos.coords.longitude]), { expires: null });
			}

			// Call callback
			cb && cb([pos.coords.latitude, pos.coords.longitude]);
		}, (_error) => {
			// PositionError {code: 1, message: "User denied Geolocation"}
			// console.warn('pos-err', err)
			if (setCookie && geoCookieName) {
				mpro.Cookies.set(geoCookieName, JSON.stringify([]), { expires: null });
			}
			// Call callback
			cb && cb([]);
		}, {
			enableHighAccuracy: highAccuracy ? true : false,
			timeout: 10_000, // Infinity
			maximumAge: 0, // Infinity
		});
	}
	else {
		if (setCookie && geoCookieName) {
			mpro.Cookies.set(geoCookieName, JSON.stringify([]), { expires: null });
		}

		// Call callback
		cb && cb([]);
	}
};

export default mpro;
